/**
 * PickTypeNameDropdownSearch Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectPickTypes } from '../../../../services/pickTypes/selectors';

// Utils
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectData = createDeepEqualSelector(
    selectPickTypes,
    pickTypesState => pickTypesState && Object.values(pickTypesState)
);

const selectFilteredData = createDeepEqualSelector(
    selectData,
    dataState => dataState
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: name
        }))
);

export { selectOptions };
